const SPELL_LEVELS = Array.from({ length: 10 }, (_, level) => level);

class SpellBook {
    constructor(json = {}) {
        this.availableMagic = json.availableMagic;
        this.spells = (json.spells ?? []).map((spellJson) => new Spell(spellJson));
        const suppliedLevels = json.spellLevels ?? [];
        this.spellLevels = SPELL_LEVELS.map((level) => {
            const supplied = suppliedLevels.find((entry) => Number(entry.level) === level) ?? {};
            return {
                level,
                known: Math.max(0, Number(supplied.known) || 0),
                perDay: Math.max(0, Number(supplied.perDay) || 0),
                cast: Math.max(0, Number(supplied.cast) || 0),
                bonus: Math.max(0, Number(supplied.bonus) || 0),
                saveDc: Math.max(0, Number(supplied.saveDc) || 0),
            };
        });
    }
}
export default SpellBook;

class Spell {
    constructor(json) {
        this.id = json.id;
        this.catalogId = json.catalogId;
        this.name = json.name;
        this.spellLevel = json.spellLevel;
        this.castTime = json.castTime;
        this.spellDuration = json.spellDuration;
        this.range = json.range;
        this.notes = json.notes;
    }
}
